/*
 * @Author: CYX
 * @Date: 2020-05-12 11:44:46
 * @LastEditors: CYX
 * @LastEditTime: 2020-07-09 18:05:49
 */ 
export const settleStepEn = {
    jcrzjg:"Testing certification body/company：",
    qsrxgxx:"Please enter relevant information",
    tyjgdm:"Unified organization code certificate：",
    qiyesuozaidi:"Enterprise location",
    jcrzfwgj:"Testing and certification service country (optional) :",
    jcrzfwxm:"Testing and certification service items (optional) :",
    gsclny:"Date of establishment:",
    xzrq:"Select a date",
    gszczb:"Registered capital:",
    gsjj:"Company profile:",
    scsfz:"Upload scanned copy of legal person id card:",
    scjcjgyyzz:"Upload the copy of the business license of the testing and certification organization (with official seal) and scan copy:",
    scjcjgzzzs:"Upload the scanned copy of the test qualification certificate:",
    scjjcl:"Upload lab/testing organization profile materials",
    scsmgdx:"Authorization letter from the operator of the registered account of the upload testing agency platform:",
    xzsmgdx:"Download the template word text, stamp it and upload it",
    tianxieruzhuzl:'Fill in the process information',
    pingtaishenghe:'Platform submit',
    ruzhuchenggong:'Settled successful',
    chenggongtijiaozl:'Data submitted successfully, please wait patiently for platform review',
    shengheshibaiqing:'Audit failed, please fill in the registration information again and submit!',
    shengheyijian:'Audit opinion',
    chongxintainxie:'Rewrite',
    gongxiningzj:'Congratulations, the expert has approved it',
    gongxining:'Congratulations, the testing organization passed the examination',
    jinrujigouglht:'Enter the organization management background',
    jinruzjgouglht:'Enter the background of expert management',
    qingshurujcjghm:'cell phone number'
}


// WEBPACK FOOTER //
// ./src/lang/home/settleStep/indexEn.js